import {XauditModel} from '../xaudit.model';
import {DocumentDataModel} from '../document/document-data.model';

export class DataARClaimAttachmentModel extends XauditModel {
  ARClaimID: string;
  ClaimAttchID: string;
  DocumentID: string;
  dataDocument: DocumentDataModel;
  enumClaimAttachmentStatusID: string;
  enumClaimAttachmentTypeID: string;
  StatusBy: string;
  StatusOn: Date;
  NoteID: string;
}
